import React, { useEffect, useRef } from "react"

type PaymentSource = "paypal" | "card" | "apple_pay" | "google-pay"

interface ButtonProps {
  createOrder?: (data: any, source: PaymentSource) => Promise<any>
  onApprove: (data: any, source: PaymentSource) => Promise<any>
  createVaultSetupToken?: (data: any, source: PaymentSource) => Promise<any>
}

export const PayPalButton: React.FC<ButtonProps> = ({
  createOrder,
  onApprove,
  createVaultSetupToken,
}) => {
  const paypalButtonRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (window.paypal && paypalButtonRef.current) {
      paypalButtonRef.current.innerHTML = ""

      window.paypal
        .Buttons({
          // fundingSource: window.paypal.FUNDING.APPLEPAY,
          ...(createOrder
            ? {
                createOrder: (data: any) => createOrder?.(data, "paypal"),
              }
            : {
                createVaultSetupToken: (data: any) =>
                  createVaultSetupToken?.(data, "paypal"),
              }),

          onApprove: (data: any) => onApprove?.(data, "paypal"),
        })
        .render(paypalButtonRef.current)
    }
  }, [createOrder, onApprove, createVaultSetupToken])

  return (
    <div
      id="paypal-button-container"
      className="paypal-button-container"
      ref={paypalButtonRef}
    />
  )
}
